import type { Dictionary } from '@/types';
import {
  generateSRPUri,
  HgSupportedLanguage,
  SearchModel,
  SRPUri,
  UrlNameResolver,
} from '@smg-real-estate/hg-search-libs';
import type { LocationQuery } from 'vue-router';
import { RouteLocationGeneric } from 'vue-router';

import { getCurrentTargetPlatform } from '@/helpers/platformDetection';
import {
  getLayoutSolutionRequestQueryParameters,
  isLayoutSolutionActive,
} from '@/layout-solution/layout-solution';

import { useGeoStore } from '@/store/modules/geo';
import { urlNameByGeoIdResolver } from './seoUrlPartResolver';

export function generateSRPRoute({
  language,
  searchModel,
  urlNameResolver,
}: {
  language: HgSupportedLanguage;
  searchModel: SearchModel;
  urlNameResolver: UrlNameResolver;
}): SRPUri {
  return generateSRPUri({
    language,
    searchModel,
    urlNameResolver,
    maxLocationsInPath: 1,
    maxSubCategoriesInPath: 3,
    platform: getCurrentTargetPlatform(),
  });
}

export function normalizeToDictionary(
  query: LocationQuery,
): Dictionary<string | (string | null)[]> {
  const result: Dictionary<string | (string | null)[]> = {};

  for (const key in query) {
    const value = query[key];
    result[key] = Array.isArray(value) ? value : [value];
  }

  return result;
}

export function createSRPRoute(
  language: HgSupportedLanguage,
  searchModel: SearchModel,
  $route: RouteLocationGeneric,
  geoStore: ReturnType<typeof useGeoStore>,
): SRPUri {
  const route = generateSRPRoute({
    language,
    searchModel,
    urlNameResolver: urlNameByGeoIdResolver(geoStore, getCurrentTargetPlatform()),
  });
  const normalizedQuery = normalizeToDictionary($route.query);

  if (isLayoutSolutionActive($route.query)) {
    route.query = {
      ...route.query,
      ...getLayoutSolutionRequestQueryParameters(normalizedQuery),
    };
  }
  return route;
}
